import React from 'react';
import Loadable from 'react-loadable';
import { Alert, Button } from 'antd';
import { RedoOutlined } from '@ant-design/icons';
import { config, Project } from 'app.config';

const { project } = config;

export const LoadingView = (props) => {
  if (props.error) {
    const errorMessage = props.error instanceof Error ? props.error.message : String(props.error);
    return (
      <>
        <Alert
          message="Error"
          description={
            <>
              <p>{errorMessage}</p>
              <p>如遇到此錯誤, 煩請截圖給相關開發人員</p>
            </>
          }
          type="error"
          showIcon
        />
        <Button
          icon={<RedoOutlined />}
          className="mt-1"
          onClick={function (e) {
            window.location.reload();
          }}
        >
          請試著重整解決此問題
        </Button>
      </>
    );
  } else if (props.pastDelay || props.isLoading) {
    return <></>;
  } else {
    return <Alert message="Warning" type="warning" showIcon />;
  }
};

export const loadable = (loader) => {
  return Loadable({
    loader,
    loading: LoadingView,
    render(loaded: { default: any; }, props: React.JSX.IntrinsicAttributes) {
      const Component = loaded.default;
      return <Component {...props} />;
    },
  });
};

export const loadablePage = {
  // general
  login: loadable(() => import('routes/login' /* webpackChunkName: "login" */)),
  index: loadable(() => import('routes/index' /* webpackChunkName: "index" */)),
  // supply-chain-management
  general: {
    users: loadable(() => import('routes/general/account/user' /* webpackChunkName: "users" */)),
    roles: loadable(() => import('routes/general/account/role' /* webpackChunkName: "roles" */)),
    stats: loadable(() => import('routes/general/stats' /* webpackChunkName: "status" */)),
    sku:
      project === Project.SupplyChainManagement
        ? loadable(() => import('routes/admin/sku' /* webpackChunkName: "adminSku" */))
        : project === Project.SuppliersManagement
        ? loadable(() => import('routes/supplier/sku' /* webpackChunkName: "supplierSku" */))
        : null,
  },
  admin: {
    suppliers: loadable(
      () => import('routes/admin/supplier' /* webpackChunkName: "adminSupplier" */)
    ),
    order: loadable(() => import('routes/admin/order/search' /* webpackChunkName: "adminOrder" */)),
    return: loadable(
      () => import('routes/admin/order/return' /* webpackChunkName: "adminReturn" */)
    ),
    announcements: loadable(
      () => import('routes/admin/announcement' /* webpackChunkName: "adminAnnouncements" */)
    ),
    backlog: loadable(() => import('routes/admin/backlog' /* webpackChunkName: "adminBacklog" */)),
    supportcase: loadable(
      () =>
        import('routes/general/supportcase' /* webpackChunkName: "adminSupportCaseManagement" */)
    ),
    records: loadable(() => import('routes/admin/records')),
  },
  supplier: {
    announcements: loadable(
      () => import('routes/supplier/announcement' /* webpackChunkName: "adminAnnouncements" */)
    ),
    outbound: loadable(
      () => import('routes/supplier/order/outbound' /* webpackChunkName: "supplierOutbound" */)
    ),
    return: loadable(
      () => import('routes/supplier/order/return' /* webpackChunkName: "supplierReturn" */)
    ),
    backlog: loadable(
      () => import('routes/supplier/backlog' /* webpackChunkName: "supplierBacklog" */)
    ),
    supportcase: loadable(
      () =>
        import('routes/general/supportcase' /* webpackChunkName: "adminSupportCaseManagement" */)
    ),
  },
};

export default loadablePage;
